import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom"; // Removed BrowserRouter
import { Helmet } from "react-helmet";
import Layout from "./components/layout/Layout";
import AppProvider from "./context/AppContext";
import './App.css'
import RocketRangeMobile from "./pages/rocketRange/mobile/RocketRangeMobile";
import RocketRangeAdmin from "./pages/rocketRange/RocketRangeAdmin";

const App: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <>
      <Helmet>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>AlphPad Play</title>
        <link rel="icon" type="image/x-icon" href="/images/logo/favicon.webp"></link>
        <link rel="preload" as="image" href="/images/logo/logo.webp"></link>
      </Helmet>

      <AppProvider>
        <Layout>
          {loading ? (
            <div className="preloader">
              <div className="preloader__inner">
                <div className="preloader__icon">
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          ) : (
            <Routes>
              <Route path="/" element={<RocketRangeMobile />} />
              <Route path="/admin/rocket-range" element={<RocketRangeAdmin />} />
              <Route path="*" element={<h1>404 - Page Not Found</h1>} />
            </Routes>
          )}
        </Layout>
      </AppProvider>
    </>
  );
};

export default App;
